import { EvScreenshotService } from '@evinced-private/ui-common';

import { AzureTicketDraft } from '../types/AzureTicketDraft';

export interface AzureScreenshotService {
	/** Composes the issue screenshot attached to an Azure work item from the draft's elements. */
	captureIssueScreenshot(draft: AzureTicketDraft): Promise<string | undefined>;
}

/**
 * Builds the screenshot service. Owned by the module since it only needs ui-common's
 * {@link EvScreenshotService} — no host-app dependency. The provider creates one instance
 * alongside `auth`/`api`, so there is no module-level mutable singleton.
 */
export const createAzureScreenshotService = (): AzureScreenshotService => {
	const screenshotService = new EvScreenshotService();

	const captureIssueScreenshot = async (draft: AzureTicketDraft): Promise<string | undefined> => {
		const boundingBoxes = draft.elements.map((element) => element.boundingBox);
		const screenshot = await screenshotService.getFullPageScreenshotWithIssues({
			pageScreenshotUrl: draft.pageScreenshot,
			boundingBoxes
		});
		return screenshot ?? undefined;
	};

	return { captureIssueScreenshot };
};
